type FlashKind = 'success' | 'error' | 'info';

interface FlashPayload {
	kind: FlashKind;
	message: string;
}

const KEY = 'flexiple_flash_toast';

export function setFlashToast(payload: FlashPayload): void {
	if (typeof window === 'undefined') return;
	try {
		sessionStorage.setItem(KEY, JSON.stringify(payload));
	} catch {
		// sessionStorage can throw in private mode - silently drop the flash
	}
}

export function consumeFlashToast(): FlashPayload | null {
	if (typeof window === 'undefined') return null;
	try {
		const raw = sessionStorage.getItem(KEY);
		if (!raw) return null;
		sessionStorage.removeItem(KEY);
		const parsed = JSON.parse(raw) as Partial<FlashPayload>;
		if (typeof parsed?.message !== 'string') return null;
		const kind = parsed.kind === 'error' || parsed.kind === 'info' ? parsed.kind : 'success';
		return { kind, message: parsed.message };
	} catch {
		return null;
	}
}
